/**
 * Appearence Animations using GSAP
 */

export class AppearenceAnimations {
  constructor() {
    this.init();
  }

  /**
   * Initialize animations
   */
  init() {
    if (
      typeof gsap === "undefined" ||
      typeof ScrollTrigger === "undefined" ||
      typeof SplitText === "undefined"
    ) {
      console.warn("GSAP, ScrollTrigger, or SplitText not loaded");
      return;
    }

    gsap.registerPlugin(ScrollTrigger, SplitText);
    this.mm = gsap.matchMedia();

    this.titles();
    this.descriptions();
    this.images();
    this.blocks();
    this.cards();
  }

  titles() {
    const titles = document.querySelectorAll("[data-title-anim]");
    if (!titles.length) return;

    titles.forEach((title) => {
      gsap.from(title, {
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: title,
          start: "top 80%",
          once: true,
        },
      });
    });
  }

  descriptions() {
    const descriptions = document.querySelectorAll("[data-description-anim]");
    if (!descriptions.length) return;

    descriptions.forEach((desc) => {
      gsap.from(desc, {
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: desc,
          start: "top 85%",
          once: true,
        },
      });
    });
  }

  images() {
    const images = document.querySelectorAll("[data-image-anim]");
    if (!images.length) return;

    images.forEach((image) => {
      gsap.from(image, {
        scale: 0.75,
        transformOrigin: "50% 50%",
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: image,
          start: "top 85%",
          once: true,
        },
      });
    });
  }

  blocks() {
    const blocks = document.querySelectorAll("[data-block-anim]");
    if (!blocks.length) return;

    blocks.forEach((block) => {
      gsap.from(block, {
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: block,
          start: "top 85%",
          once: true,
        },
      });
    });
  }

  cards() {
    const cards = document.querySelectorAll("[data-cards-anim]");
    if (!cards.length) return;

    cards.forEach((card) => {
      const cards = card.querySelectorAll("[data-card]");

      cards.forEach((el, index) => {
        gsap.from(el, {
          y: 50,
          opacity: 0,
          duration: 0.8,
          delay: index * 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            once: true,
          },
        });
      });
    });
  }
}
